import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const createOrder = async ({data}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/wc/v3/orders?`)
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
    }
}
export const getOrderById = async ({id}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/wc/v3/orders/${id}?`)
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
        return error
    }
}
export const updateOrder = async ({id, data}) => {
    const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/wc/v3/orders/${id}?`)
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'PUT',
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.message)
        }
        return await response.json()
    } catch (error) {
    }
}
